<template>
  <div class="select-attachable-category-by-customer-and-category-component"
       v-bind:class="{loaded}"
       data-dusk=""
  >
    <a-tabs v-if="hasCategories" :default-active-key="defaultActiveKey" :tab-bar-style="{height:40}" size="small">
      <a-tab-pane v-if="hasMainCategories" key="main_categories" tab="Mappen">
        <a-select :disabled="disabled" @change="onMainCategoryChange" placeholder="Selecteer..."
                  style="width:100%">
          <a-select-option :key="key" :value="key" style="width:100%" v-for="(category, key) in mainCategories">
            {{ category.name }}
          </a-select-option>
        </a-select>
      </a-tab-pane>
      <a-tab-pane v-if="hasSubCategories" key="sub_categories" tab="Submappen">
        <a-select :disabled="disabled" @change="onSubCategoryChange" placeholder="Selecteer..."
                  style="width:100%">
          <a-select-opt-group v-for="(subCategory, subCategoryKey) in subCategories" :key="subCategoryKey">
        <span slot="label">
          <span>{{ subCategory.has_attachable.data.description || '' }}</span>
          -
          <span>{{ subCategory.has_attachable.data.name || '' }}</span>
        </span>
            <a-select-option :key="subCategoryKey + '-' + subCategoryAttachableCategoryKey"
                             :value="subCategoryKey + '-' + subCategoryAttachableCategoryKey"
                             v-for="(category, subCategoryAttachableCategoryKey) in subCategory.attachable_categories.data">
              {{ category.name }}
            </a-select-option>
          </a-select-opt-group>
        </a-select>
      </a-tab-pane>
    </a-tabs>
    <div v-else>
      Er zijn in deze categorie (nog) geen mappen.
    </div>
  </div>
</template>

<script>
import attachableCategoryApi from "~/api/attachable_category"

export default {
  name: "AttachableCategorySelectByCustomerAndCategoryComponent",
  components: {},
  props: {
    customer: {
      type: Object,
      required: true
    },
    category: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
      mainCategories: [],
      subCategories: [],
      selectedAttachableCategory: null,
    };
  },
  created() {
    this.initAttachableCategories();
  },
  computed: {
    hasCategories() {
      return this.hasMainCategories || this.hasSubCategories;
    },
    hasMainCategories() {
      return this.mainCategories.length > 0;
    },
    hasSubCategories() {
      return this.subCategories.length > 0;
    },
    defaultActiveKey() {
      return this.hasMainCategories ? 'main_categories' : 'sub_categories'
    }
  },
  methods: {
    initAttachableCategories() {
      attachableCategoryApi.getForHasAttachableAndMainCategory('customer', this.customer.id, this.category).then(response => {
        this.mainCategories = response.data.main_categories.data;
        this.subCategories = response.data.sub_categories.data;
        this.loaded = true;
      })
    },
    onMainCategoryChange(val) {
      let attachableCategory = this.mainCategories[val];

      if (attachableCategory.template === true) {
        attachableCategoryApi.createFromTemplate('customer', this.customer.id, attachableCategory.id).then(response => {
          this.selectedAttachableCategory = response.data
          this.$emit('category-selected', response.data);
        })
      } else {
        this.selectedAttachableCategory = attachableCategory;
        this.$emit('category-selected', attachableCategory);
      }
    },
    onSubCategoryChange(val) {
      let keys = val.split('-'),
          subCategory = this.subCategories[keys[0]],
          hasAttachable = subCategory.has_attachable.data,
          subCategoryAttachableCategory = subCategory.attachable_categories.data[keys[1]];

      if (subCategoryAttachableCategory.template === true) {
        attachableCategoryApi.createFromTemplate(hasAttachable.type, hasAttachable.id, subCategoryAttachableCategory.id).then(response => {
          this.selectedAttachableCategory = response.data
          this.$emit('category-selected', response.data);
        })
      } else {
        this.selectedAttachableCategory = subCategoryAttachableCategory;
        this.$emit('category-selected', subCategoryAttachableCategory);
      }
    }
  }
}
</script>
<style scoped>
</style>
